import React from "react";

const DataSourceDoc = (
    <>
        <p>
            Select live for live trading. Simulated will create randomized stock price
            movement, starting from 100$ a share.
        </p>
    </>
);
export default DataSourceDoc;
